module.exports = __webpack_public_path__ + "img/monitorbox18.f0ea08dc.jpg";